export default "__VITE_ASSET__Dt20a8ff__"